
import React from "react";
import { TableRow, TableCell } from "@/components/ui/table";
import { WorksheetLinksCell } from "./WorksheetLinksCell";
import { StatusColumn } from "./worksheet/StatusColumn";
import { StudentInfo } from "./worksheet/StudentInfo";
import { TeachingInfo } from "./worksheet/TeachingInfo";
import { Report } from "@/types/report";

interface WorksheetCheckTableRowProps {
  report: Report;
  normalizedStatus: "WAITING" | "APPROVED" | "REJECTED";
  loadingId: string | null;
  dialogOpenFor: string | null;
  setDialogOpenFor: (id: string | null) => void;
  handleApprove: (status: "APPROVED" | "REJECTED", note: string) => Promise<void>;
  mapStatusToColor: Record<string, string>;
  mapStatusToLabel: Record<string, string>;
}

export const WorksheetCheckTableRow: React.FC<WorksheetCheckTableRowProps> = ({
  report,
  normalizedStatus,
  loadingId,
  dialogOpenFor,
  setDialogOpenFor,
  handleApprove,
  mapStatusToColor,
  mapStatusToLabel
}) => {
  return (
    <TableRow key={report.id}>
      <TeachingInfo 
        teachingDate={report.teaching_date}
        teachingTimeSlot={report.teaching_time_slot}
        teacherDisplay={report.teacher_display}
        subject={report.subject}
        content={report.topic_learned || report.teaching_content}
        isOtherSubject={report.other_subject}
      />
      <StudentInfo 
        fullName={report.student_full_name}
        nickname={report.student_nickname}
        gradeLevel={report.student_grade_level}
      />
      <WorksheetLinksCell
        worksheet_urls={report.worksheet_urls}
        worksheet_drive_link={report.worksheet_drive_link}
      />
      <TableCell>
        <StatusColumn 
          reportId={report.id}
          normalizedStatus={normalizedStatus}
          loadingId={loadingId}
          dialogOpenFor={dialogOpenFor}
          setDialogOpenFor={setDialogOpenFor}
          handleApprove={handleApprove}
          mapStatusToColor={mapStatusToColor}
          mapStatusToLabel={mapStatusToLabel}
          approved_at={report.approved_worksheet_at}
          approved_by={report.approved_worksheet_by}
          approved_note={report.approved_worksheet_note}
        />
      </TableCell>
    </TableRow>
  );
};
